
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Utiles } from '@/__env/pluggins/event-bus';


    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        public Abierto: boolean = false;

        mounted()
        {
            Utiles.onNuevaVersion.subscribe( x =>
            {

                if ( x )
                    this.Abrir();
                else
                    this.Cerrar();
            } );
        }

        Abrir()
        {
            this.Abierto = false;
            this.$nextTick( () => this.Abierto = true );
        }

        Listo()
        {
            window.location.reload( true );
        }

        Cerrar()
        {
            this.Abierto = false;
        }
    }
